// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogueTitle {
    font-size: 35px;
    fill: solid rgba(42, 114, 222, 0.75);
    color: #2A72DE;
    font-size: SemiBold;
    line-height: 53px;
}

.dialogueTitle2 {
    font-size: 35px;
    fill: solid rgba(42, 114, 222, 0.75);
    color: #2A72DE;
    font-size: SemiBold;
    line-height: 53px;
    margin-top: 0;
    margin-bottom: 30px;
    padding-top: 0;
}

.formlabel {
    display: flex;
    flex-direction: column;

}

.stackrow {
    display: "flex";
    flex-direction: "row";
    justify-content: "center";
    gap: "10%";
}

.proceedbutton {
    color: #2A72DE;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 80px;

}

.listitems {
    color: #4a77ff;
    font-size: 15px;
    line-height: 175%;
}

.formtext {
    width: 330px;
    height: 35px;
    text-align: center;
    border-radius: 20px;
    background-color: #94D2FF;
    border: #BFBFBF;
}

textarea {
    resize: none;
}

label {
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #4a77ff;
}

.passwordbar {
    margin-top: 3%;
    width: 330px;
    height: 35px;
    text-align: center;
    border-radius: 20px;
    background-color: #94D2FF;
    border: #BFBFBF;
    margin-right: 2%;
}

.passwordbar2 {
    margin-top: 3%;
    width: 330px;
    height: 35px;
    text-align: center;
    border-radius: 20px;
    background-color: #94D2FF;
    border: #BFBFBF;
    margin-right: 5%;
}

.registerbutton1 {
    color: #2A72DE;
    background-color: rgba(42, 114, 222, 0.15);
    border-radius: 80px;
    cursor: pointer;
    width: 400px;
    height: 50px;
    border-color: transparent;
    font-size: 24px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5%;
}

.registerbutton {
    color: #2A72DE;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 80px;

    color: #2A72DE;
    margin-top: 5%;
    width: 300px;
    height: 50px;
    border-radius: 80px;
    font-size: 24px;
    margin-left: auto;
    margin-right: auto;
}

.divrow {
    margin-top: 2%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10%;
    text-align: center;
}

.passwordrow {
    display: flex;
    margin-top: 3%;
    flex-direction: row;
    justify-content: center;
    gap: 10%;
    text-align: center;
}

.divrowcb {
    margin-top: 2%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
}

.inutbar {
    width: 250px;
    color: #2A72DE;
    background-color: #94D2FF;
    border-radius: 20px;
    height: 35px;
    margin-right: 5%;
    align-items: center;
    text-align: center;
    font-size: larger;
}

.userpasswordbar {
    font-size: larger;

    width: 330px;
    height: 35px;
    text-align: center;
    border-radius: 20px;
    background-color: #94D2FF;
    border: #BFBFBF;
    margin-right: 2%;
}

.userpasswordbar2 {
    font-size: larger;
    width: 330px;
    height: 35px;
    text-align: center;
    border-radius: 20px;
    background-color: #94D2FF;
    border: #BFBFBF;
    margin-right: 2%;
}

.inutbarcb {
    width: 25px;
    color: #2A72DE;
    background-color: #94D2FF;
    border-radius: 20px;
    height: 35px;
    align-items: center;
    text-align: center;
    font-size: larger;
}

.cblabel {
    margin-top: 0.5%;
    margin-left: 1%;
}

.emailphone {
    margin-left: 2%;
}

.phonenumber {
    margin-left: 2%;
    width: 250px;
    color: #2A72DE;
    background-color: #94D2FF;
    border-radius: 20px;
    height: 35px;

    align-items: center;
    text-align: center;
    font-size: larger;
}

.carddiv {
    padding: 5%;
    align-items: center;
    text-align: center;
}

.backbutton {
    margin: 2% 1.2%;
}

.backbutton2 {
    margin: 2%;
    margin-bottom: 0;
    padding-bottom: 0;
}

.billbriefs {
    margin-top: 10%;
}

.rowstack {
    display: flex;
    flex-direction: row;
}

.sidebar-search-input {
    width: 90%;
    border-radius: 4px;
    margin: 0 auto 15px auto;
    background-color: #F5F5F5;
    border: 1px solid #e9ecef;
    outline: none;
    font-size: x-large;
}

.divrowmid {
    /* text-align: center; */
    font-size: 20px;
    display: flex;
    justify-content: center;
    gap: 2%;
}

.midrow {
    display: flex;
    justify-content: center;
    gap: 25%;
    margin-top: 3%;
}

.variables {
    text-align: center;
}

.variablediv {
    display: flex;
    flex-direction: row;
}

.variableComponents {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 2%;
    margin-bottom: 2%;
}

.variabledivlabel {
    margin-right: 2%;
}

.fileup {
    margin-top: 5%;
}

.emailinutbar {
    border-radius: 20px;
    width: 330px;
    height: 35px;
    border: 1px solid gray;
    text-align: center;
}

.emailinutbar2 {
    border-radius: 20px;
    width: 206px;
    height: 35px;
    border: 1px solid gray;
    text-align: center;
}

.divstack {
    display: flex;
    margin-top: 5%;
    justify-content: flex-end;
    gap: 2%;
}

.accordianheadings {
    color: #2A72DE;
    margin-bottom: 0%;
    padding-bottom: 0%;
}

.ulistBlock {
    align-items: center;
    justify-content: center;
    width: 50%;
}

.emailsubmit {
    background-color: #4A77FF;
    border-radius: 20px;
    width: 101px;
    height: 44px;
    color: #ffffff;
    border: transparent;
    cursor: pointer;
}

.emailcancel {
    background-color: #9B9B9B;
    border-radius: 20px;
    width: 101px;
    height: 44px;
    color: #ffffff;
    border: transparent;
    cursor: pointer;
}

.btns {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    gap: 5%;
    justify-content: center;
    margin-top: 5%;
}

.filldetailspage {
    align-items: center;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.editor {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/UsersModalList.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,mBAAmB;;IAEnB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;;IAEjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;;IAEZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,OAAO;AACX;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".dialogueTitle {\n    font-size: 35px;\n    fill: solid rgba(42, 114, 222, 0.75);\n    color: #2A72DE;\n    font-size: SemiBold;\n    line-height: 53px;\n}\n\n.dialogueTitle2 {\n    font-size: 35px;\n    fill: solid rgba(42, 114, 222, 0.75);\n    color: #2A72DE;\n    font-size: SemiBold;\n    line-height: 53px;\n    margin-top: 0;\n    margin-bottom: 30px;\n    padding-top: 0;\n}\n\n.formlabel {\n    display: flex;\n    flex-direction: column;\n\n}\n\n.stackrow {\n    display: \"flex\";\n    flex-direction: \"row\";\n    justify-content: \"center\";\n    gap: \"10%\";\n}\n\n.proceedbutton {\n    color: #2A72DE;\n    background-color: rgba(0, 0, 0, 0.25);\n    border-radius: 80px;\n\n}\n\n.listitems {\n    color: #4a77ff;\n    font-size: 15px;\n    line-height: 175%;\n}\n\n.formtext {\n    width: 330px;\n    height: 35px;\n    text-align: center;\n    border-radius: 20px;\n    background-color: #94D2FF;\n    border: #BFBFBF;\n}\n\ntextarea {\n    resize: none;\n}\n\nlabel {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    color: #4a77ff;\n}\n\n.passwordbar {\n    margin-top: 3%;\n    width: 330px;\n    height: 35px;\n    text-align: center;\n    border-radius: 20px;\n    background-color: #94D2FF;\n    border: #BFBFBF;\n    margin-right: 2%;\n}\n\n.passwordbar2 {\n    margin-top: 3%;\n    width: 330px;\n    height: 35px;\n    text-align: center;\n    border-radius: 20px;\n    background-color: #94D2FF;\n    border: #BFBFBF;\n    margin-right: 5%;\n}\n\n.registerbutton1 {\n    color: #2A72DE;\n    background-color: rgba(42, 114, 222, 0.15);\n    border-radius: 80px;\n    cursor: pointer;\n    width: 400px;\n    height: 50px;\n    border-color: transparent;\n    font-size: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 5%;\n}\n\n.registerbutton {\n    color: #2A72DE;\n    background-color: rgba(0, 0, 0, 0.25);\n    border-radius: 80px;\n\n    color: #2A72DE;\n    margin-top: 5%;\n    width: 300px;\n    height: 50px;\n    border-radius: 80px;\n    font-size: 24px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.divrow {\n    margin-top: 2%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 10%;\n    text-align: center;\n}\n\n.passwordrow {\n    display: flex;\n    margin-top: 3%;\n    flex-direction: row;\n    justify-content: center;\n    gap: 10%;\n    text-align: center;\n}\n\n.divrowcb {\n    margin-top: 2%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    text-align: center;\n}\n\n.inutbar {\n    width: 250px;\n    color: #2A72DE;\n    background-color: #94D2FF;\n    border-radius: 20px;\n    height: 35px;\n    margin-right: 5%;\n    align-items: center;\n    text-align: center;\n    font-size: larger;\n}\n\n.userpasswordbar {\n    font-size: larger;\n\n    width: 330px;\n    height: 35px;\n    text-align: center;\n    border-radius: 20px;\n    background-color: #94D2FF;\n    border: #BFBFBF;\n    margin-right: 2%;\n}\n\n.userpasswordbar2 {\n    font-size: larger;\n    width: 330px;\n    height: 35px;\n    text-align: center;\n    border-radius: 20px;\n    background-color: #94D2FF;\n    border: #BFBFBF;\n    margin-right: 2%;\n}\n\n.inutbarcb {\n    width: 25px;\n    color: #2A72DE;\n    background-color: #94D2FF;\n    border-radius: 20px;\n    height: 35px;\n    align-items: center;\n    text-align: center;\n    font-size: larger;\n}\n\n.cblabel {\n    margin-top: 0.5%;\n    margin-left: 1%;\n}\n\n.emailphone {\n    margin-left: 2%;\n}\n\n.phonenumber {\n    margin-left: 2%;\n    width: 250px;\n    color: #2A72DE;\n    background-color: #94D2FF;\n    border-radius: 20px;\n    height: 35px;\n\n    align-items: center;\n    text-align: center;\n    font-size: larger;\n}\n\n.carddiv {\n    padding: 5%;\n    align-items: center;\n    text-align: center;\n}\n\n.backbutton {\n    margin: 2% 1.2%;\n}\n\n.backbutton2 {\n    margin: 2%;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.billbriefs {\n    margin-top: 10%;\n}\n\n.rowstack {\n    display: flex;\n    flex-direction: row;\n}\n\n.sidebar-search-input {\n    width: 90%;\n    border-radius: 4px;\n    margin: 0 auto 15px auto;\n    background-color: #F5F5F5;\n    border: 1px solid #e9ecef;\n    outline: none;\n    font-size: x-large;\n}\n\n.divrowmid {\n    /* text-align: center; */\n    font-size: 20px;\n    display: flex;\n    justify-content: center;\n    gap: 2%;\n}\n\n.midrow {\n    display: flex;\n    justify-content: center;\n    gap: 25%;\n    margin-top: 3%;\n}\n\n.variables {\n    text-align: center;\n}\n\n.variablediv {\n    display: flex;\n    flex-direction: row;\n}\n\n.variableComponents {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-right: 2%;\n    margin-bottom: 2%;\n}\n\n.variabledivlabel {\n    margin-right: 2%;\n}\n\n.fileup {\n    margin-top: 5%;\n}\n\n.emailinutbar {\n    border-radius: 20px;\n    width: 330px;\n    height: 35px;\n    border: 1px solid gray;\n    text-align: center;\n}\n\n.emailinutbar2 {\n    border-radius: 20px;\n    width: 206px;\n    height: 35px;\n    border: 1px solid gray;\n    text-align: center;\n}\n\n.divstack {\n    display: flex;\n    margin-top: 5%;\n    justify-content: flex-end;\n    gap: 2%;\n}\n\n.accordianheadings {\n    color: #2A72DE;\n    margin-bottom: 0%;\n    padding-bottom: 0%;\n}\n\n.ulistBlock {\n    align-items: center;\n    justify-content: center;\n    width: 50%;\n}\n\n.emailsubmit {\n    background-color: #4A77FF;\n    border-radius: 20px;\n    width: 101px;\n    height: 44px;\n    color: #ffffff;\n    border: transparent;\n    cursor: pointer;\n}\n\n.emailcancel {\n    background-color: #9B9B9B;\n    border-radius: 20px;\n    width: 101px;\n    height: 44px;\n    color: #ffffff;\n    border: transparent;\n    cursor: pointer;\n}\n\n.btns {\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    gap: 5%;\n    justify-content: center;\n    margin-top: 5%;\n}\n\n.filldetailspage {\n    align-items: center;\n    width: 60%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.editor {\n    width: 60%;\n    margin-left: auto;\n    margin-right: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
